<div class="detail-header">
  <button
    type="button"
    class="al-page-back al-relief-icon al-relief-icon--large al-icon--chevron-left"
    (click)="back.emit()"
    [attr.aria-label]="'buttons.back' | translate"
    [nbTooltip]="'buttons.back' | translate"
    nbTooltipPlacement="right"
  ><span class="al-relief-glyph" aria-hidden="true"></span></button>

  <div class="participant-info">
    <span class="presence-dot" [class.online]="isOnline"></span>
    <h3>{{ getParticipantName() }}</h3>
    <span class="email-label" *ngIf="participant.email">{{ participant.email }}</span>
    <span class="last-seen" *ngIf="!isOnline && lastSeen">
      {{ "pages.dozent.participants.profile.lastSeen" | translate }}: {{ lastSeen | date: "dd.MM.yy HH:mm" }}
    </span>
  </div>
</div>

<nb-tabset (changeTab)="onTabChange($event.tabId)">
  <!-- Tab 1: General Info -->
  <nb-tab tabId="general" [tabTitle]="'pages.dozent.participants.profile.general' | translate">
    <div class="tab-content">
      <h4>{{ "pages.dozent.participants.profile.enrollments" | translate }}</h4>
      <app-page-loader *ngIf="isLoadingEnrollments"></app-page-loader>
      <table class="detail-table" *ngIf="!isLoadingEnrollments && enrollments.length > 0">
        <thead>
          <tr>
            <th>{{ "pages.dozent.participants.profile.course" | translate }}</th>
            <th>{{ "pages.dozent.participants.profile.enrolledAt" | translate }}</th>
            <th>{{ "pages.dozent.participants.profile.source" | translate }}</th>
            <th>{{ "pages.dozent.participants.profile.status" | translate }}</th>
            <th>{{ "pages.dozent.participants.profile.grade" | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let e of pagedEnrollments">
            <td>{{ e.course_name }}</td>
            <td>{{ e.enrolled_at | date: "dd.MM.yy" }}</td>
            <td><span class="badge">{{ e.enrollment_source }}</span></td>
            <td><span class="badge" [class.active]="e.enrollment_status === 'active'">{{ e.enrollment_status }}</span></td>
            <td>{{ e.grade }}</td>
          </tr>
        </tbody>
      </table>
      <app-pagination
        *ngIf="!isLoadingEnrollments && enrollments.length > 0"
        class="detail-pagination"
        [totalItems]="enrollments.length"
        [itemsPerPage]="enrollmentPageSize"
        [currentPage]="enrollmentPage"
        [pageSizeOptions]="pageSizeOptions"
        (pageChanged)="onEnrollmentPageChange($event)"
        (itemsPerPageChange)="onEnrollmentPageSizeChange($event)"
      ></app-pagination>
    </div>
  </nb-tab>

  <!-- Tab: Kompetenzprofil (PRD competency-profile). The tab id stays
       "learning-state" — the old Lernstand table is the area rows now. -->
  <nb-tab tabId="learning-state" [tabTitle]="'pages.dozent.participants.learningState.tab' | translate">
    <div class="tab-content">
      <app-competency-profile
        [profile]="competencyProfile"
        [loading]="isLoadingCompetency"
        [error]="competencyError"
        [defaultCourseId]="currentCourseId"
        (retry)="loadCompetencyProfile()"
      ></app-competency-profile>
    </div>
  </nb-tab>

  <!-- Tab 2: Learner Profile — learner-profile v2 (app-learner-memory reads
       `view` from al-tutor learner_memory_ops.memory_view) -->
  <nb-tab tabId="profile" [tabTitle]="'pages.dozent.participants.profile.learnerProfile' | translate">
    <div class="tab-content">
      <app-learner-memory [data]="learnerProfile" [loading]="isLoadingProfile" [competency]="competencyProfile"></app-learner-memory>
    </div>
  </nb-tab>

  <!-- Tab 3: Exercises -->
  <nb-tab tabId="exercises" [tabTitle]="'pages.dozent.participants.profile.exercises' | translate">
    <div class="tab-content">
      <div class="tab-actions-row">
        <button
          nbButton
          size="small"
          status="primary"
          appearance="outline"
          (click)="openAssignExerciseDialog()"
        >
          <nb-icon icon="plus-outline"></nb-icon>
          {{ "pages.dozent.participants.profile.assignExercise" | translate }}
        </button>
      </div>

      <app-page-loader *ngIf="isLoadingExercises"></app-page-loader>

      <div *ngIf="!isLoadingExercises && exercises.length === 0" class="empty-hint">
        {{ "pages.dozent.participants.profile.noExercises" | translate }}
      </div>

      <table class="detail-table" *ngIf="exercises.length > 0">
        <thead>
          <tr>
            <th>{{ "pages.dozent.participants.profile.assignment" | translate }}</th>
            <th *ngIf="!currentCourseId">{{ "pages.dozent.participants.profile.course" | translate }}</th>
            <th>{{ "pages.dozent.participants.profile.status" | translate }}</th>
            <th>{{ "pages.dozent.participants.profile.aiScore" | translate }}</th>
            <th>{{ "pages.dozent.participants.profile.dozentScore" | translate }}</th>
            <th>{{ "pages.dozent.participants.profile.submittedAt" | translate }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let ex of pagedExercises">
            <tr class="clickable" (click)="toggleExercise(ex)">
              <td>{{ ex.assignment_title || '—' }}</td>
              <td *ngIf="!currentCourseId">{{ ex.course_name || '—' }}</td>
              <td><span class="badge">{{ ex.status }}</span></td>
              <td>{{ ex.ai_score != null ? ex.ai_score : '—' }}</td>
              <td>{{ ex.dozent_score != null ? ex.dozent_score : '—' }}</td>
              <td>{{ ex.submitted_at | date: "dd.MM.yy" }}</td>
              <td>
                <nb-icon [icon]="expandedExercise === exerciseRowId(ex) ? 'chevron-up-outline' : 'chevron-down-outline'"></nb-icon>
              </td>
            </tr>
            <tr *ngIf="expandedExercise === exerciseRowId(ex)" class="expanded-row">
              <td [attr.colspan]="currentCourseId ? 6 : 7">
                <div class="expanded-detail">
                  <div class="grading-result" *ngIf="resultScore(ex) != null || resultFeedback(ex) || hasStructuredReview(ex)">
                    <div class="result-header">
                      <h4>{{ "pages.dozent.participants.resultOverview" | translate }}</h4>
                      <span class="result-source-badge" [ngClass]="resultSourceClass(ex)">
                        <nb-icon icon="award-outline"></nb-icon>
                        {{ resultSourceLabelKey(ex) | translate }}
                      </span>
                    </div>

                    <div class="score-row">
                      <span class="label">{{ "pages.dozent.participants.score" | translate }}:</span>
                      <span class="value">
                        {{ resultScore(ex) ?? "—" }}
                        <span class="muted" *ngIf="resultMaxScore(ex) != null">
                          / {{ resultMaxScore(ex) }}
                        </span>
                      </span>
                    </div>

                    <div class="feedback-block" *ngIf="resultFeedback(ex)">
                      <div class="label">{{ "pages.dozent.participants.feedback" | translate }}:</div>
                      <p class="feedback-text">{{ resultFeedback(ex) }}</p>
                    </div>

                    <div class="question-feedback-list" *ngIf="hasStructuredReview(ex)">
                      <div class="section-label">
                        {{ "pages.dozent.participants.questionFeedback" | translate }}
                      </div>

                      <div
                        class="question-feedback"
                        *ngFor="let result of structuredQuestions(ex)"
                        [ngClass]="questionStatusClass(result)"
                      >
                        <div class="question-feedback-header">
                          <div class="question-title">
                            <span class="question-number">{{ result.question_index + 1 }}.</span>
                            <span>
                              {{
                                result.question_text ||
                                  getQuestionText(questionList(ex)[result.question_index], result.question_index)
                              }}
                            </span>
                          </div>
                          <div class="question-score">
                            <span class="status-pill">
                              {{
                                (result.correct
                                  ? "pages.dozent.participants.questionCorrect"
                                  : "pages.dozent.participants.questionIncorrect"
                                ) | translate
                              }}
                            </span>
                            <span class="points">
                              {{ result.points ?? 0 }}
                              <span *ngIf="result.max_points != null">/ {{ result.max_points }}</span>
                            </span>
                          </div>
                        </div>

                        <div class="option-review" *ngIf="hasOptionResults(result)">
                          <div
                            class="review-option"
                            *ngFor="let option of result.option_results"
                            [ngClass]="optionStatusClass(option)"
                          >
                            <span class="option-marker">{{ optionStatusSymbol(option) }}</span>
                            <span class="option-text">{{ option.text }}</span>
                            <span class="option-state">
                              {{ optionStatusLabelKey(option) | translate }}
                            </span>
                          </div>
                        </div>

                        <div class="blank-review" *ngIf="hasBlankResults(result)">
                          <div
                            class="blank-row"
                            *ngFor="let blank of result.blank_results"
                            [class.correct]="blank.correct"
                          >
                            <span class="blank-label">
                              {{ "pages.dozent.participants.answer" | translate }} {{ (blank.index ?? 0) + 1 }}:
                            </span>
                            <span class="blank-answer">{{ blank.submitted || "—" }}</span>
                            <span class="blank-expected" *ngIf="!blank.correct">
                              {{ "pages.dozent.participants.correctAnswer" | translate }}: {{ blank.expected || "—" }}
                            </span>
                          </div>
                        </div>

                        <div
                          class="plain-answer-review"
                          *ngIf="!hasOptionResults(result) && !hasBlankResults(result)"
                        >
                          <div *ngIf="formatValues(result.selected)">
                            <span class="mini-label">{{ "pages.dozent.participants.answer" | translate }}:</span>
                            {{ formatValues(result.selected) }}
                          </div>
                          <div *ngIf="formatValues(result.correct_answers)">
                            <span class="mini-label">{{ "pages.dozent.participants.correctAnswer" | translate }}:</span>
                            {{ formatValues(result.correct_answers) }}
                          </div>
                        </div>

                        <p class="question-feedback-text" *ngIf="result.feedback">
                          <span class="mini-label">{{ "pages.dozent.participants.feedback" | translate }}:</span>
                          {{ result.feedback }}
                        </p>
                        <p class="question-explanation" *ngIf="result.explanation">
                          <span class="mini-label">{{ "pages.dozent.participants.explanation" | translate }}:</span>
                          {{ result.explanation }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="raw-review" *ngIf="!hasStructuredReview(ex)">
                    <h4>{{ "pages.dozent.participants.answers" | translate }}</h4>
                    <div class="answers">
                      <div class="qa" *ngFor="let q of questionList(ex); let i = index">
                        <div class="q">
                          <strong>{{ i + 1 }}.</strong>
                          {{ getQuestionText(q, i) }}
                        </div>
                        <div class="a">{{ answerFor(ex, q, i) || "—" }}</div>
                        <div class="correct" *ngIf="getCorrectAnswer(q)">
                          <span class="muted">{{ "pages.dozent.participants.correctAnswer" | translate }}:</span>
                          {{ getCorrectAnswer(q) }}
                        </div>
                      </div>

                      <div class="qa" *ngIf="questionList(ex).length === 0 && rawAnswerEntries(ex).length > 0">
                        <div class="raw-answer-row" *ngFor="let answer of rawAnswerEntries(ex)">
                          <span class="mini-label">{{ answer.key }}:</span>
                          {{ answer.value || "—" }}
                        </div>
                      </div>

                      <div class="qa" *ngIf="questionList(ex).length === 0 && rawAnswerEntries(ex).length === 0">
                        <em class="muted">{{ "pages.dozent.participants.noQuestionsHint" | translate }}</em>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
      <app-pagination
        *ngIf="!isLoadingExercises && exercises.length > 0"
        class="detail-pagination"
        [totalItems]="exercises.length"
        [itemsPerPage]="exercisePageSize"
        [currentPage]="exercisePage"
        [pageSizeOptions]="pageSizeOptions"
        (pageChanged)="onExercisePageChange($event)"
        (itemsPerPageChange)="onExercisePageSizeChange($event)"
      ></app-pagination>
    </div>
  </nb-tab>

  <!-- Tab 4: Communication -->
  <nb-tab tabId="communication" [tabTitle]="'pages.dozent.participants.profile.communication' | translate">
    <div class="tab-content">
      <app-page-loader *ngIf="isLoadingConversations"></app-page-loader>

      <div class="tab-actions-row">
        <button
          nbButton
          size="small"
          status="primary"
          (click)="showNewMessageForm = !showNewMessageForm"
        >
          <nb-icon icon="paper-plane-outline"></nb-icon>
          {{ "pages.dozent.participants.profile.startConversation" | translate }}
        </button>
      </div>

      <!-- New conversation form -->
      <nb-card *ngIf="showNewMessageForm" class="new-conv-form" size="tiny">
        <nb-card-body>
          <textarea
            nbInput
            fullWidth
            [placeholder]="'pages.dozent.participants.profile.messagePlaceholder' | translate"
            [(ngModel)]="newConvMessage"
            rows="3"
          ></textarea>
          <div class="form-actions">
            <button
              nbButton
              size="small"
              status="primary"
              (click)="onStartConversation()"
              [disabled]="!newConvMessage.trim() || isCreatingConversation"
              [nbSpinner]="isCreatingConversation"
              nbSpinnerSize="tiny"
              nbSpinnerStatus="control"
            >
              {{ "buttons.send" | translate }}
            </button>
            <button nbButton size="small" ghost (click)="showNewMessageForm = false">
              {{ "buttons.cancel" | translate }}
            </button>
          </div>
        </nb-card-body>
      </nb-card>

      <div *ngIf="!isLoadingConversations && conversations.length === 0 && !showNewMessageForm" class="empty-hint">
        {{ "pages.dozent.participants.profile.noConversations" | translate }}
      </div>

      <table class="detail-table" *ngIf="conversations.length > 0">
        <thead>
          <tr>
            <th>{{ "pages.dozent.participants.profile.convTitle" | translate }}</th>
            <th *ngIf="!currentCourseId">{{ "pages.dozent.participants.profile.course" | translate }}</th>
            <th>{{ "pages.dozent.participants.profile.source" | translate }}</th>
            <th>{{ "pages.dozent.participants.profile.status" | translate }}</th>
            <th>{{ "pages.dozent.participants.profile.createdAt" | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let conv of pagedConversations" class="clickable">
            <td>
              <span class="conv-title-cell">{{ conv.title || ("pages.dozent.participants.profile.untitledConversation" | translate) }}</span>
            </td>
            <td *ngIf="!currentCourseId">{{ conv.course_name || '—' }}</td>
            <td>
              <span class="badge" [ngClass]="{
                'escalation': conv.source === 'ai_escalation',
                'active': conv.source === 'learner'
              }">{{ conv.source }}</span>
            </td>
            <td>
              <span class="badge" [ngClass]="{
                'resolved': conv.status === 'resolved',
                'open': conv.status === 'open'
              }">
                {{ conv.status === 'resolved' ? ('pages.dozent.participants.profile.resolved' | translate) : ('pages.dozent.participants.profile.open' | translate) }}
              </span>
            </td>
            <td>{{ conv.created_at | date: "dd.MM.yy HH:mm" }}</td>
          </tr>
        </tbody>
      </table>
      <app-pagination
        *ngIf="!isLoadingConversations && conversations.length > 0"
        class="detail-pagination"
        [totalItems]="conversations.length"
        [itemsPerPage]="conversationPageSize"
        [currentPage]="conversationPage"
        [pageSizeOptions]="pageSizeOptions"
        (pageChanged)="onConversationPageChange($event)"
        (itemsPerPageChange)="onConversationPageSizeChange($event)"
      ></app-pagination>
    </div>
  </nb-tab>
</nb-tabset>
